<div class="wrapper-domain-list">
  <ng-template #guideModal001>
    <div class="card modal-content">
      <div class="row">
        <div class="col">
          <button
            type="button"
            class="close text-primary"
            (click)="closeModal()"
          >
            <i class="fi fi-rs-cross-small"></i>
          </button>
          <h2 class="text-xl font-semibold">
            {{ "Add CNAME Record" | translate }}
          </h2>
          <p class="mb-4">
            {{
              "You need to add our CNAME record to your domain DNS record. It's
            easy, we promise!" | translate
            }}
          </p>

          <div
            class="py-3 py-3 bg-slate-50 border !border-slate-200/[1] rounded"
          >
            <ol class="list list-inside mt-1 list-decimal !px-5">
              <li>
                {{
                  "Login to your domain registrar (eg. Name.com, Namecheap,
                GoDaddy, Exabytes etc.)" | translate
                }}
              </li>
              <li>
                {{
                  "Go to DNS Management page to add new dns record" | translate
                }}
              </li>
              <li>
                {{ "Add the following data as CNAME record" | translate }}:

                <table
                  class="table cname-table mt-3 mb-4 bg-slate-100 border !border-slate-200/[0.7] rounded"
                >
                  <tbody>
                    <tr>
                      <td>
                        <div class="form-group">
                          <label for="cnameName"
                            ><strong class="mr-2">1.</strong>
                            {{ "CNAME Name" | translate }}</label
                          >
                          <div class="input-group mb-3">
                            <input
                              id="cnameName"
                              type="text"
                              readonly
                              class="form-control white-input"
                              (focus)="selectAll($event)"
                              [value]="selectedDomain.cnameName"
                            />
                            <div class="input-group-append">
                              <span
                                class="input-group-text !bg-slate-300"
                                id="basic-addon2"
                                >.{{ selectedDomain.cnameDomainName }}</span
                              >
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="form-group">
                          <label for="cnameValue"
                            ><strong class="mr-2">2</strong
                            >{{ "CNAME Value" | translate }}
                          </label>
                          <textarea
                            readonly
                            id="cnameValue"
                            class="form-control white-input no-resize"
                            (focus)="selectAll($event)"
                            >{{ selectedDomain.cnameValue }}</textarea
                          >
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>
              <li>
                {{
                  "Once it is done, press the following button to continue the
                process." | translate
                }}
                <div class="row">
                  <div class="col flex !p-2 justify-center mt-3">
                    <button
                      class="btn-domain-input bg-emerald-500 text-white py-3 px-3 rounded shadow-sm hover:bg-emerald-600 duration-300 ease-in-out transition"
                      (click)="cnameSubmitted(selectedDomain)"
                    >
                      <i class="fi fi-rs-check px-3"></i>
                      {{
                        "Yes, I have added the CNAME Record to the DNS Record"
                          | translate
                      }}
                    </button>
                  </div>
                </div>
              </li>
            </ol>
          </div>
          <div class="modal-footer p-0 mt-3">
            <div class="mt-2">
              <button
                class="bg-white text-orange-600 border !border-orange-600 py-2 px-4 rounded shadow-sm hover:!shadow hover:!text-white hover:!bg-orange-600 duration-300 ease-in-out transition"
                (click)="closeModal()"
              >
                {{ "Close" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Modal: Manage subdomains -->
  <ng-template #manageSubdomainsModal>
    <div class="card modal-content">
      <div class="row">
        <div class="col">
          <button
            type="button"
            class="close text-primary"
            (click)="closeModal()"
          >
            <i class="fi fi-rs-cross-small"></i>
          </button>
          <div class="flex items-center justify-between">
            <h2 class="text-xl font-semibold">
              {{ "Manage Subdomain" | translate }}
            </h2>
            <span class="text-xs text-slate-500">
              {{ getSubdomainList(selectedDomain).length }}/5
            </span>
          </div>
          <p class="mb-4 text-slate-600">
            {{ "Add or remove subdomains for this domain." | translate }}
          </p>

          <div class="p-2 bg-slate-50 border !border-slate-200/[1] rounded">
            <div
              *ngIf="getSubdomainList(selectedDomain).length; else emptySubs"
            >
              <ul class="flex flex-col gap-2">
                <li
                  class="flex items-center justify-between bg-white border !border-slate-200 rounded px-3 py-2"
                  *ngFor="let sub of getSubdomainList(selectedDomain)"
                >
                  <span class="text-slate-700 text-sm">{{ sub }}</span>
                  <button
                    class="inline-flex items-center gap-1 px-2 py-1 rounded bg-red-50 text-red-600 hover:bg-red-100 border border-red-200 text-xs"
                    (click)="deleteSubdomain(sub)"
                  >
                    <i class="fi fi-rs-trash"></i>
                    {{ "Delete" | translate }}
                  </button>
                </li>
              </ul>
            </div>
            <ng-template #emptySubs>
              <div class="text-slate-400 text-sm">
                {{ "No subdomains yet." | translate }}
              </div>
            </ng-template>
          </div>

          <div class="modal-footer p-0 mt-3 flex gap-2">
            <button
              class="bg-white text-slate-600 border !border-slate-300 py-2 px-4 rounded shadow-sm hover:!shadow hover:!text-slate-700 hover:!bg-slate-50 duration-300 ease-in-out transition"
              (click)="closeModal()"
            >
              {{ "Close" | translate }}
            </button>
            <button
              class="bg-emerald-500 text-white py-2 px-4 rounded shadow-sm hover:bg-emerald-600 duration-300 ease-in-out transition disabled:opacity-50 disabled:cursor-not-allowed"
              [disabled]="getSubdomainList(selectedDomain).length >= 5"
              [title]="getSubdomainList(selectedDomain).length >= 5 ? ( 'Maximum 5 subdomains' | translate ) : ''"
              (click)="openSubdomainPrompt(selectedDomain)"
            >
              <i class="fi fi-rs-plus-small"></i>
              {{ "Add subdomain" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Modal: Ask user which subdomain they entered -->
  <ng-template #subdomainModal>
    <div class="card modal-content">
      <div class="row">
        <div class="col">
          <button
            type="button"
            class="close text-primary"
            [disabled]="isVerifying"
            (click)="closeSubdomainModal()"
          >
            <i class="fi fi-rs-cross-small"></i>
          </button>
          <h2 class="text-xl font-semibold">
            {{ "Which subdomain did you enter?" | translate }}
          </h2>
          <p class="mb-4 text-slate-600">
            {{
              "Tell us the subdomain you added in your DNS so we can verify it points to the correct address."
                | translate
            }}
          </p>

          <div class="p-2 bg-slate-50 border !border-slate-200/[1] rounded">
            <div class="form-group">
              <label for="enteredSubdomain" class="mb-1"
                >{{ "Subdomain" | translate }}
                <small class="text-slate-500"
                  >({{ "e.g." | translate }} store, shop, @, * )</small
                ></label
              >
              <input
                id="enteredSubdomain"
                type="text"
                class="form-control white-input"
                (input)="userSubdomain = $event.target.value"
                [value]="userSubdomain || ''"
                placeholder="store / shop / @ / *"
              />
            </div>
          </div>

          <div class="modal-footer p-0 mt-3 flex gap-2">
            <button
              class="bg-white text-slate-600 border !border-slate-300 py-2 px-4 rounded shadow-sm hover:!shadow hover:!text-slate-700 hover:!bg-slate-50 duration-300 ease-in-out transition disabled:opacity-50 disabled:cursor-not-allowed"
              [disabled]="isVerifying"
              (click)="closeSubdomainModal()"
            >
              {{ "Cancel" | translate }}
            </button>
            <button
              class="bg-emerald-500 text-white py-2 px-4 rounded shadow-sm hover:bg-emerald-600 duration-300 ease-in-out transition disabled:opacity-50 disabled:cursor-not-allowed"
              [disabled]="isVerifying"
              (click)="proceedVerifySubdomain()"
            >
              <span *ngIf="isVerifying" class="spinner-border spinner-border-sm me-1" role="status"></span>
              {{ (isVerifying ? "Verifying..." : "Verify subdomain") | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #guideModal002>
    <div class="card modal-content">
      <div class="row">
        <div class="col">
          <button
            type="button"
            class="close text-primary"
            (click)="closeModal()"
          >
            <i class="fi fi-rs-cross-small"></i>
          </button>
          <h2 class="text-xl font-semibold" (click)="testClose()">
            {{ "Add CNAME Record" | translate }} 2
          </h2>
          <p class="mb-4">
            {{
              "Now you will need to add another CNAME or ALIAS record"
                | translate
            }}
          </p>

          <div
            class="py-3 py-3 bg-slate-50 border !border-slate-200/[1] rounded"
          >
            <ol class="list list-inside mt-1 list-decimal !px-5">
              <li>
                {{
                  "Log in to your Domain Registrar (e.g. Namecheap, GoDaddy, Exabytes, etc.)"
                    | translate
                }}
              </li>
              <li>
                {{
                  "Go to the DNS Management page. This is where you add or edit DNS records."
                    | translate
                }}
              </li>
              <li>
                {{
                  "Add a new record. Choose either ALIAS or CNAME (depends on your registrar)."
                    | translate
                }}
              </li>
              <li>
                {{ "Set the" | translate }}
                <strong>{{ "Name" | translate }}</strong>
                {{ "field" | translate }}:
                <ul class="list-disc list-inside mt-2">
                  <li>
                    {{ "Want your store at" | translate }}
                    <strong>store.{{ selectedDomain.domain_name }}</strong
                    >? {{ "Enter" | translate }} <strong>store</strong>
                  </li>
                  <li>
                    {{ "Want it at" | translate }}
                    <strong>shop.{{ selectedDomain.domain_name }}</strong
                    >? {{ "Enter" | translate }} <strong>shop</strong>
                  </li>
                  <li>
                    {{ "Want it to work for any subdomain?" | translate }}
                    {{ "Enter" | translate }} <strong>*</strong> ({{
                      "wildcard" | translate
                    }})
                  </li>
                  <li>
                    {{ "Want to point the main domain" | translate }}
                    (<strong>{{ selectedDomain.domain_name }}</strong
                    >)? {{ "Enter" | translate }} <strong>@</strong>
                    {{ "or choose ALIAS (varies by registrar)" | translate }}
                  </li>
                </ul>

                <table
                  class="table cname-table mt-3 mb-4 bg-slate-100 border !border-slate-200/[0.7] rounded"
                >
                  <tbody>
                    <tr>
                      <td>
                        <div class="form-group">
                          <label for="recordName"
                            ><strong class="mr-2">1.</strong
                            >{{ "Record Name" | translate }}</label
                          >
                          <input
                            id="recordName"
                            type="text"
                            readonly
                            class="form-control white-input"
                            (focus)="selectAll($event)"
                            value="<store / shop / * / @>"
                          />
                          <small class="text-slate-500">
                            {{ "Use one of the options above." | translate }}
                          </small>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="form-group">
                          <label for="recordValue"
                            ><strong class="mr-2">2.</strong
                            >{{ "Record Value / Points To" | translate }}</label
                          >
                          <input
                            id="recordValue"
                            type="text"
                            readonly
                            class="form-control white-input"
                            (focus)="selectAll($event)"
                            [value]="selectedDomain.cf_dist_domain_name"
                          />
                          <small class="text-slate-500">
                            {{
                              "This should always point to the CloudFront address above."
                                | translate
                            }}
                          </small>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>
              <li>
                {{
                  "Save the DNS record. Changes may take a few minutes to take effect."
                    | translate
                }}
              </li>
              <li>
                {{
                  "Once you’re done, press the button below to continue."
                    | translate
                }}
                <div class="row">
                  <div class="col flex !p-2 justify-center mt-3">
                    <button
                      class="btn-domain-input bg-emerald-500 text-white py-3 px-3 rounded shadow-sm hover:bg-emerald-600 duration-300 ease-in-out transition"
                      (click)="openSubdomainPrompt(selectedDomain)"
                    >
                      <i class="fi fi-rs-check px-3"></i>
                      {{ "Yes, I’ve added the DNS record" | translate }}
                    </button>
                  </div>
                </div>
              </li>
            </ol>
          </div>
          <div class="modal-footer p-0 mt-3">
            <div class="mt-2">
              <button
                class="bg-white text-orange-600 border !border-orange-600 py-2 px-4 rounded shadow-sm hover:!shadow hover:!text-white hover:!bg-orange-600 duration-300 ease-in-out transition"
                (click)="closeModal()"
              >
                {{ "Close" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #detailsModal>
    <div class="card modal-content">
      <div class="row">
        <div class="col">
          <button
            type="button"
            class="close text-primary"
            (click)="closeModal()"
          >
            <i class="fi fi-rs-cross-small"></i>
          </button>
          <h2 class="text-xl font-semibold">
            {{ "Domain Details" | translate }}
          </h2>
          <p class="mb-4">{{ "Details for current domain" | translate }}</p>

          <div class="">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>{{ "Property" | translate }}</th>
                  <th>{{ "Value" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="property-column">
                    {{ "Domain Name" | translate }}
                  </td>
                  <td>{{ selectedDomain.domain_name }}</td>
                </tr>
                <tr>
                  <td class="property-column">{{ "Type" | translate }}</td>
                  <td>
                    {{
                      "{0}"
                        | translate
                          : [
                              utils.translate(
                                selectedDomain.is_existing_domain
                                  ? "Existing Domain"
                                  : "New Domain"
                              )
                            ]
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="property-column">{{ "Status" | translate }}</td>
                  <td>
                    <span
                      [class]="'status-text status-' + selectedDomain.status"
                    >
                      <i
                        class="fi fi-rr-clock-nine"
                        *ngIf="selectedDomain.status == 1"
                      ></i>
                      {{
                        "{0}"
                          | translate
                            : [
                                utils.translate(
                                  displayStatus(selectedDomain.status)
                                )
                              ]
                      }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td class="property-column">
                    {{ "Progress Code" | translate }}
                  </td>
                  <td>{{ selectedDomain.setup_progress }}</td>
                </tr>
                <tr>
                  <td class="property-column">
                    {{ "Certificate Resource Record" | translate }}
                  </td>
                  <td>
                    <div *ngIf="selectedDomain.resource_record">
                      <table class="table cname-table table-bordered mt-3 mb-4">
                        <tbody>
                          <tr class="bg-blue">
                            <td>
                              <div class="form-group">
                                <label for="cnameName"
                                  ><strong class="mr-2">1.</strong>
                                  {{
                                    "CNAME
                                  Name" | translate
                                  }}</label
                                >
                                <div class="input-group mb-3">
                                  <input
                                    id="cnameName"
                                    type="text"
                                    readonly
                                    class="form-control white-input"
                                    (focus)="selectAll($event)"
                                    [value]="selectedDomain.cnameName"
                                  />
                                  <div class="input-group-append">
                                    <span
                                      class="input-group-text !bg-slate-300"
                                      id="basic-addon2"
                                      >.{{
                                        selectedDomain.cnameDomainName
                                      }}</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="bg-blue">
                            <td>
                              <div class="form-group">
                                <label for="cnameValue"
                                  ><strong class="mr-2">2</strong
                                  >{{
                                    "CNAME
                                  Value" | translate
                                  }}
                                </label>
                                <textarea
                                  readonly
                                  id="cnameValue"
                                  class="form-control white-input no-resize"
                                  (focus)="selectAll($event)"
                                  >{{ selectedDomain.cnameValue }}</textarea
                                >
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div *ngIf="!selectedDomain.resource_record">
                      <span class="empty-value">{{
                        "Not yet ready" | translate
                      }}</span>
                    </div>
                  </td>
                </tr>
                <!-- <tr>
                                    <td class="property-column">Hosted Zone Name Server</td>
                                    <td>
                                        <div *ngIf="selectedDomain.hosted_zone_delegation_set">
                                            <textarea readonly class="form-control white-input no-resize"
                                                (focus)="selectAll($event)">{{selectedDomain.hosted_zone_delegation_set}}</textarea>
                                        </div>
                                        <div *ngIf="!selectedDomain.hosted_zone_delegation_set"><span
                                                class="empty-value">Not
                                                yet ready</span></div>
                                    </td>
                                </tr> -->
                <tr>
                  <td class="property-column">
                    {{ "Distribution Domain Name" | translate }}
                  </td>
                  <td>
                    <div *ngIf="selectedDomain.cf_dist_domain_name">
                      <input
                        id="cfDomain"
                        type="text"
                        readonly
                        class="form-control white-input"
                        (focus)="selectAll($event)"
                        [value]="selectedDomain.cf_dist_domain_name"
                      />
                    </div>
                    <div *ngIf="!selectedDomain.cf_dist_domain_name">
                      <span class="empty-value">{{
                        "Not yet ready" | translate
                      }}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer p-0 mt-3">
            <div class="mt-2">
              <button
                class="bg-white text-orange-600 border !border-orange-600 py-2 px-4 rounded shadow-sm hover:!shadow hover:!text-white hover:!bg-orange-600 duration-300 ease-in-out transition"
                (click)="closeModal()"
              >
                {{ "Close" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="section-title">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <div class="title">{{ "Domain" | translate }}</div>
        </div>
      </div>
      <div class="col text-right">
        <div class="d-inline-block topbar-actions">
          <button class="btn btn-primary" routerLink="/dashboard/domain-form">
            {{ "Add Domain" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="section-main">
    <div *ngIf="isLoading" class="text-center">
      <div class="loading-spinner col-12">
        <mat-spinner class="mx-auto my-5" [diameter]="50"></mat-spinner>
      </div>
    </div>

    <div
      *ngIf="!isLoading"
      class="table-history table-responsive mx-auto shadow-md rounded-md"
    >
      <table class="table">
        <thead>
          <tr>
            <th class="text-start w-150" scope="col">
              {{ "Domain" | translate }}
            </th>
            <th class="text-center" scope="col">
              {{ "Subdomains" | translate }}
            </th>
            <th class="text-center" scope="col">
              {{ "Setup Progress" | translate }}
            </th>
            <th class="text-center" scope="col">{{ "Action" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of domainList">
            <td class="text-start text-slate-600">
              {{ data.domain_name }}
            </td>
            <td class="text-start text-slate-600">
              <ng-container
                *ngIf="getSubdomainList(data).length; else noSubdomains"
              >
                <div class="flex flex-wrap gap-2">
                  <ng-container *ngFor="let sub of getSubdomainList(data)">
                    <a
                      *ngIf="isClickableSubdomain(sub)"
                      class="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-emerald-50 text-emerald-700 hover:bg-emerald-100 border border-emerald-200 text-xs"
                      [href]="buildSubdomainUrl(sub, data.domain_name)"
                      target="_blank"
                      rel="noopener noreferrer"
                      (click)="$event.stopPropagation()"
                    >
                      {{ sub }}
                    </a>
                    <span
                      *ngIf="!isClickableSubdomain(sub)"
                      class="inline-flex items-center px-2 py-1 rounded-full bg-slate-100 text-slate-500 border border-slate-200 text-xs"
                      [title]="
                        sub === '*' ? ('Wildcard — cannot be opened directly' | translate) :
                        sub === '@' ? ('Root domain' | translate) : ''
                      "
                    >
                      {{ sub }}
                    </span>
                  </ng-container>
                </div>
              </ng-container>
              <ng-template #noSubdomains>
                <span class="text-slate-400 text-sm">{{
                  "None" | translate
                }}</span>
              </ng-template>
            </td>
            <td class="text-center relative">
              <div class="relative pt-1">
                <div class="flex mb-2 items-center justify-between"
                [class]="{'justify-content-center': +data.setup_progress >= finalStep}">
                  <div>
                    <span
                      class="text-[0.7rem] bg-slate-100 text-slate-400 font-semibold inline-block py-1 px-2 uppercase rounded-full"
                      [class]="{
                        '!text-red-400': +data.status === 9,
                        '!bg-grey-100': +data.status === 9,
                        '!text-orange-400': +data.status === 8,
                        '!bg-orange-100': +data.status === 8,
                        '!text-rose-400': +data.status === 3,
                        '!bg-rose-100': +data.status === 3,
                        '!text-green-600': +data.status === 2,
                        '!bg-green-200': +data.status === 2,
                        '!text-sky-400': +data.status === 1,
                        '!bg-sky-100': +data.status === 1
                      }"
                    >
                      <i
                        class="fi fi-rr-clock-nine"
                        *ngIf="data.status == 1"
                      ></i>
                      {{
                        "{0}"
                          | translate
                            : [utils.translate(displayStatus(data.status))]
                      }}
                    </span>
                  </div>
                  <div class="text-right" *ngIf="+data.setup_progress < finalStep">
                    <span
                      class="text-xs font-semibold inline-block text-slate-400"
                      [class]="{
                        'text-rose-400': data.status == 3,
                        'text-green-600': data.status == 2,
                        'text-sky-400': data.status == 1
                      }"
                    >
                      {{ data.setup_progress }}/{{ finalStep }} [{{
                        getPercentage(data.setup_progress, finalStep)
                      }}]
                    </span>
                  </div>
                </div>
                <div
                  *ngIf="data.status == 1"
                  class="overflow-hidden h-2 text-xs flex rounded bg-slate-200"
                >
                  <div
                    [style]="{
                      width: getPercentage(data.setup_progress, finalStep)
                    }"
                    class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-slate-300"
                    [class]="{
                      'bg-rose-400': data.status == 3,
                      'bg-green-400': data.status == 2,
                      'bg-sky-400': data.status == 1
                    }"
                  ></div>
                </div>
              </div>

              <div
                class="text-center absolute z-10 w-full bg-white top-0"
                *ngIf="+data.status === 1 && +data.is_waiting_user_input === 1"
              >
                <sub class="text-slate-500 top-0 relative">
                  <span class="relative top-[2px] right-5">
                    <i
                      class="fi fi-rs-exclamation text-emerald-600 absolute top-0 left-0 animate-ping"
                    ></i>
                    <i
                      class="fi fi-rs-exclamation text-emerald-600 absolute top-0 left-0"
                    ></i>
                  </span>
                  {{ "Your action is required" | translate }}</sub
                ><br />
                <button
                  class="inline-flex py-1 px-3 rounded-md bg-emerald-500 user-select-none justify-center items-center transition duration-300 ease-in-out drop-shadow-md !border-0 text-white hover:text-emerald-200 hover:!bg-emerald-600"
                  (click)="showUserInput(data)"
                >
                  {{ "Take Action" | translate }}
                </button>
              </div>
            </td>
            <td class="text-end action-buttons">
              <button
                type="button"
                *ngIf="
                  +data.setup_progress === 22 || +data.setup_progress === 23
                "
                class="btn-styles rounded ml-2 px-2 py-1 bg-white justify-center items-center h-7 text-xs transition duration-300 ease drop-shadow-xs hover:drop-shadow border-gray-200 group-hover:border-indigo-300 hover:!border-indigo-200 !border text-indigo-600 hover:!bg-indigo-50/[0.5] group hover:no-underline"
                (click)="openManageSubdomains(data)"
              >
                <i class="fi fi-rs-settings"></i>
                <span class="ml-1">{{ "Manage subdomains" | translate }}</span>
              </button>
              <button
                type="button"
                class="btn-styles rounded ml-2 px-2 py-1 bg-white justify-center text-xs items-center h-7 transition duration-300 ease drop-shadow-xs hover:drop-shadow border-gray-200 group-hover:border-indigo-300 hover:!border-indigo-200 !border text-indigo-600 hover:!bg-indigo-50/[0.5] group hover:no-underline"
                #tooltip="matTooltip"
                matTooltip="View information for domain setup"
                matTooltipPosition="above"
                matTooltipHideDelay="100"
                (click)="showDetails(data)"
              >
                <i class="fi fi-rs-info"></i>
                <span class="ml-1">{{ "View Details" | translate }}</span>
              </button>
              <button
                type="button"
                class="btn-styles rounded ml-2 px-2 py-1 bg-white justify-center items-center h-7 text-xs transition duration-300 ease drop-shadow-xs hover:drop-shadow border-gray-200 group-hover:border-red-300 hover:!border-red-200 !border text-red-600 hover:!bg-red-50/[0.5] group hover:no-underline"
                #tooltip="matTooltip"
                matTooltip="Remove domain"
                matTooltipPosition="above"
                matTooltipHideDelay="100"
                [class]="{
                  'is-loading': isDeleting(data)
                }"
                (click)="deleteDomain(data)"
              >
                <i class="fi fi-rs-trash"></i>
                <span class="ml-1">{{ "Remove" | translate }}</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
